import PriorityLevelTag from './PriorityLevelTag';

export default PriorityLevelTag;
